import { SVGProps, Ref, forwardRef } from 'react';

export const PenSquareOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.67 1.914 7 12.584V17h4.415l10.67-10.67a3.122 3.122 0 0 0-4.415-4.416m2.171 4.115-1.87-1.87.972-.972a1.322 1.322 0 1 1 1.87 1.87zM16.7 5.432 8.8 13.33v1.87h1.87l7.898-7.899z"
                fill="currentColor"
            />
            <path
                d="M1 13c0-8.405 1.153-9.89 9-9.994v1.8c-1.668.023-2.937.11-3.92.295-1.154.217-1.737.54-2.088.89-.351.352-.674.935-.891 2.089C2.88 9.25 2.8 10.826 2.8 13s.08 3.75.3 4.92c.218 1.155.54 1.738.892 2.089.35.35.934.673 2.087.89 1.172.22 2.747.301 4.921.301s3.75-.08 4.92-.3c1.155-.218 1.737-.54 2.089-.891.35-.351.673-.934.89-2.088.185-.984.272-2.252.295-3.92h1.8c-.104 7.846-1.589 9-9.994 9-8.75 0-10-1.25-10-10"
                fill="currentColor"
            />
        </g>
    </svg>
));
PenSquareOutlinedSize24Glyph.displayName = 'PenSquareOutlinedSize24Glyph';
